export const blockIconsCommonactionsQuestionMarkNew = (
	<span className='material-symbols-outlined'>question_mark</span>
);
